import { IAppState } from '../../common/state';
import { getNewbuildingCallPriceCarouselExperimentGroup } from 'shared/utils/experiments/getNewbuildingCallPriceCarouselExperimentGroup';

export const selectIsNewbuildingOffersWithBannerCarouselVisible = (state: IAppState) => {
  const groupName = getNewbuildingCallPriceCarouselExperimentGroup(state.abUseExperiments);

  if (!state.newbuildingInformation) {
    return false;
  }

  if (!state.featureToggle.isNewbuildingOffersCarouselEnabled) {
    return false;
  }

  return groupName === 'C';
};
